<template>
  <div class="loop-item category-item">
    <div>
      <div class="item-image">
        <img :src="item.image" alt />
      </div>
      <div class="category-info">
        <h3>{{item.title[$i18n.locale] || item.title.en}}</h3>
        <div class="item-description">{{item.slogan}}</div>
        <router-link :to="$i18nRoute({name: 'shop', params: {taxonomy: item.slug}})">
          <button class="button">{{$t("shop_now")}}</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  data () {
    return {}
  }
}
</script>

<style lang="scss">
  .category-item{
    .item-image{
      margin-bottom: 0;
    }
    .category-info{
      position: absolute;
      bottom: 65px;
      left: 60px;
      right: 60px;

      @include mq($ms){
        bottom: 15px;
        left: 15px;
        right: 15px;

        .button{
          width: 100%;
        }
      }

      h3{
        text-transform: uppercase;
        font-size: 46px;

        @include mq($ms){
          font-size: 24px;
        }
      }

      .item-description{
        margin-bottom: 20px;
      }
    }
  }
</style>
